<template>
  <el-dialog
    id="leaderEngagementDetails"
    :visible.sync="showLocal"
    @open="mode = 'details'"
  >
    <template v-if="mode === 'details'">
      <span slot="title">
        {{ $t('coach.engagements.leaderDetail.title') }}
      </span>

      <div class="label">
        {{ $t('coach.engagements.leaderDetail.coachingCategory') }}
      </div>
      <div
        v-if="formattedCategory"
        class="value"
      >
        {{ formattedCategory }}
      </div>
      <div
        v-else
        class="value"
      >
        {{ $t(`coachingTier.tier_${engagement.tier}`) }}
        {{ $t(`coachingTier.tier_${engagement.tier}_caption`) }}
      </div>

      <div class="label">
        {{ $t('common.email') }}
      </div>
      <div class="value">
        {{ engagement.leader_info.email }}
      </div>

      <el-row :gutter="20">
        <el-col :span="responsiveCol">
          <div class="label">
            {{ $t('common.duration') }}
          </div>
          <div class="value">
            {{ engagement.duration }} {{ $t('coach.engagements.durationSessions') }}
          </div>
        </el-col>

        <el-col :span="responsiveCol">
          <div class="label">
            {{ $t('common.totalFeePayout') }}
          </div>
          <div class="value">
            {{ formattedCategoryFee }}
          </div>
        </el-col>
      </el-row>

      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center;"
      >
        <el-button
          v-if="engagement.is_invited"
          type="primary"
          style="word-break: break-word; white-space: normal;"
          round
          @click="mode = 'newEngagement'"
        >
          {{ $t('coach.engagements.leaderDetail.startNewEngagement') }}
        </el-button>
        <el-button
          v-else
          type="primary"
          round
          @click="showLocal = false"
        >
          Close
        </el-button>
      </div>
    </template>

    <template v-else-if="mode === 'newEngagement'">
      <span slot="title">
        {{ $t('coach.engagements.leaderDetail.startNewEngagement') }}
      </span>

      <div style="margin-bottom: 10px; margin-top: 20px;">
        {{ $t('coach.engagements.leaderDetail.selectDuration') }}
      </div>

      <el-select
        v-model="selectedDuration"
        :placeholder="`${$t('common.select')} ${$t('common.duration')}`"
      >
        <el-option
          v-for="item in durationList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <!--<div style="margin-bottom: 10px; margin-top: 20px;">
        {{ $t('coach.engagements.leaderDetail.selectTier') }}
      </div>

      <el-select
        v-model="selectedTier"
        :placeholder="`${$t('common.select')} ${$t('common.tier')}`"
      >
        <el-option
          v-for="item in tierList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>-->

      <div style="font-style: italic; margin-top: 20px;">
        {{ $t('coach.engagements.leaderDetail.desc') }}

        <!--<i18n path="coach.engagements.leaderDetail.question">
          <template #email>
            Support@GlobalCoachGroup.com
          </template>
        </i18n>-->
      </div>

      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center;"
      >
        <el-button
          round
          @click="showLocal = false"
        >
          {{ $t('common.cancel') }}
        </el-button>
        <el-button
          type="primary"
          round
          @click="createNewEngagement"
        >
          {{ $t('common.start') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';
import api from '@/api';

export default {
  name: 'EngagementLeaderDetails',

  mixins: [dialog],

  props: {
    engagement: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      // mode: 'details',
      mode: 'newEngagement',
      selectedDuration: 10,
      durationList: [
        { value: 4, label: `4 ${this.$t('coach.engagements.durationSessions')}` },
        { value: 7, label: `7 ${this.$t('coach.engagements.durationSessions')}` },
        { value: 10, label: `10 ${this.$t('coach.engagements.durationSessions')}` },
        { value: 13, label: `13 ${this.$t('coach.engagements.durationSessions')}` },
      ],
      selectedTier: 0,
      tierList: [
        { value: 1, label: `${this.$t('common.tier')} 1` },
        { value: 2, label: `${this.$t('common.tier')} 2` },
        { value: 3, label: `${this.$t('common.tier')} 3` },
        { value: 4, label: `${this.$t('common.tier')} 4` },
        { value: 5, label: `${this.$t('common.tier')} 5` },
        { value: 6, label: `${this.$t('common.tier')} 6` },
        { value: 7, label: `${this.$t('common.tier')} 7` },
        { value: 8, label: `${this.$t('common.tier')} 8` },
      ],
    };
  },

  computed: {
    responsiveCol() {
      let col = 12;
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col = 24;
      }
      return col;
    },

    formattedCategory() {
      let defaultCategory = null;

      if (process.env.VUE_APP_SERVICE === 'ing_gcg_platform') {
        defaultCategory = this.$t('coachingTier.ingLeaders');
      }

      return defaultCategory;
    },

    formattedCategoryFee() {
      let charge = this.$t('common.na');
      if (!this.engagement.is_invited
        && this.engagement.leader_info.total_payment_fee
        && this.engagement.leader_info.total_payment_fee !== 'N/A') {
        charge = `$ ${this.engagement.leader_info.total_payment_fee}`;
      }
      return charge;
    },
  },

  methods: {
    async createNewEngagement() {
      try {
        const data = {
          duration: this.selectedDuration,
          leader_uuid: this.engagement.leader_info.uuid,
          tier: this.selectedTier,
        };
        await api.postNewEngagement(data);
        this.$message.success(this.$t('coach.engagements.newEngagementSuccess'));
        this.showLocal = false;
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss">
#leaderEngagementDetails {
  .el-dialog__body {
    padding-top: 0;
  }

  .label {
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 10px;
  }
}
</style>
